import { apiCrudBuilder, baseUrl } from "components/shared/apiCrudBuilder";

const path = `${baseUrl}/people-company-weight`;

export const { useGetAll: useAllPeopleCompanyWeight } = apiCrudBuilder(
  path,
  "PeopleCompanyWeight",
);
